<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-comment-dollar"></i> Komisi Grader
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/komisi-graders"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="status" slot-scope="props">
                            <span v-if="props.rowData.komisi_grader_id" class="badge badge-pill badge-success">Terbayar</span>
                            <span v-else class="badge badge-pill badge-warning">Pending</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="($can('create komisi grader') && (props.rowData.terbayar_pada ? isSameDay(props.rowData.terbayar_pada) : true)) || isSuperAdmin" type="button" title="Pembayaran" @click="pembayaran(props.rowData)" class="btn btn-link px-1"><i class="fas fa-hand-holding-usd"></i></button>
                            <button v-if="props.rowData.komisi_grader_id && isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="viewModal" size="md" :hide-header="true" :hide-footer="true">
            <viewer :isPembayaran="isPembayaran" :value="currentPembelian" @saved="saved" @cancel="viewModal = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';

export default {
    name: "komisi-grader",

    components: {
        SearchBar,
        Viewer,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentPembelian: null,
            searchText: '',
            searchDate: '',
            searchStatus: '',
            searchGudangId: '',
            searchGraderId: '',
            viewModal: false,
            showScanQrCode: false,
            isPembayaran: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'created_at',
                    title: 'Tanggal',
                    sortField: 'tanggal',
                    callback: 'formatDate',
                },
                {
                    name: 'grader',
                    title: 'Grader',
                    sortField: 'grader_name',
                },
                {
                    name: 'gudang',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'total_bobot',
                    title: 'Berat (kg)',
                    sortField: 'total_bobot',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:status',
                    title: 'Status',
                    sortField: 'terbayar_pada',
                },
                {
                    name: 'terbayar_pada',
                    title: 'Pada',
                    sortField: 'terbayar_pada',
                    callback: 'formatDate',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                status: this.searchStatus,
                gudang_id: this.searchGudangId,
                grader_id: this.searchGraderId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchStatus = search.searchStatus;
            this.searchGudangId = search.searchGudangId;
            this.searchGraderId = search.searchGraderId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchStatus = '';
            this.searchGudangId = '';
            this.searchGraderId = '';
            this.refresh();
        },

        pembayaran(rowData) {
            this.isPembayaran = true;
            this.currentPembelian = Object.assign({}, rowData);
            this.viewModal = true;
        },

        view(rowData) {
            this.isPembayaran = false;
            this.currentPembelian = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.viewModal = false;
            this.currentPembelian = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/komisi-graders/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/komisi-graders/' + rowData.komisi_grader_id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
